/* eslint-disable */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`;

export const SpaceY: any = styled.div`
  height; ${(props: any) => props.x}px;
`;

export const RowSpace = styled.div`
 display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const RowSpaceMT = styled.div`
 display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;
